(()=>{
 const carousel=document.querySelector('.portal-service-carousel');if(!carousel)return;
 let state={mode:'manual'},direction=1,last=0,position=carousel.scrollLeft,pauseUntil=0,pointer=null,dragged=false,raf;
 const pause=()=>{pauseUntil=performance.now()+3000;position=carousel.scrollLeft;};
 carousel.addEventListener('portal:services-design',event=>{
  state={...state,...event.detail};
  const font=state.font==='hand'?'PortalCoverHand, cursive':state.font==='times'?'"Times New Roman", serif':'Jost, sans-serif';
  for(const card of carousel.querySelectorAll(':scope > button')){
   card.style.backgroundColor=state.fill;card.style.borderColor=state.border;card.style.fontFamily=font;
   for(const text of card.querySelectorAll('.service-copy strong,.service-copy small')){text.style.color=state.text;text.style.fontFamily=font;}
   for(const icon of card.querySelectorAll('.service-icon'))icon.style.color=state.border;
  }
  carousel.style.scrollSnapType=state.mode==='automatic'?'none':'';position=carousel.scrollLeft;last=0;
 });
 // Pause from the last user interaction, including momentum after touch/trackpad gestures.
 carousel.addEventListener('wheel',pause,{passive:true});
 carousel.addEventListener('keydown',event=>{pause();if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();carousel.scrollBy({left:(event.key==='ArrowLeft'?-1:1)*carousel.clientWidth*.8,behavior:'smooth'});}});
 carousel.addEventListener('scroll',()=>{if(performance.now()<pauseUntil)pause();},{passive:true});
 carousel.addEventListener('pointerdown',event=>{if(event.button!==0)return;pause();dragged=false;pointer={id:event.pointerId,type:event.pointerType,x:event.clientX,y:event.clientY,left:carousel.scrollLeft};});
 carousel.addEventListener('pointermove',event=>{
  if(!pointer||event.pointerId!==pointer.id)return;pause();
  if(pointer.type!=='mouse')return;
  const dx=event.clientX-pointer.x;if(!dragged&&Math.abs(dx)>6&&Math.abs(dx)>Math.abs(event.clientY-pointer.y)){dragged=true;carousel.setPointerCapture(event.pointerId);}
  if(dragged){event.preventDefault();carousel.scrollLeft=pointer.left-dx;position=carousel.scrollLeft;}
 });
 const release=()=>{if(pointer){pointer=null;pause();}};
 window.addEventListener('pointerup',release);window.addEventListener('pointercancel',release);
 carousel.addEventListener('lostpointercapture',release);
 carousel.addEventListener('click',event=>{if(dragged){event.preventDefault();event.stopImmediatePropagation();dragged=false;}},true);
 function tick(now){
  const elapsed=last?Math.min(now-last,50):0;last=now;
  if(state.mode==='automatic'&&!pointer&&now>=pauseUntil&&!document.hidden&&carousel.getClientRects().length){
   const max=carousel.scrollWidth-carousel.clientWidth;
   if(max>0){position=Math.max(0,Math.min(max,position+direction*elapsed*.04));carousel.scrollLeft=position;if(position>=max)direction=-1;else if(position<=0)direction=1;}
  }else position=carousel.scrollLeft;
  raf=requestAnimationFrame(tick);
 }
 raf=requestAnimationFrame(tick);window.addEventListener('pagehide',()=>cancelAnimationFrame(raf));
 document.dispatchEvent(new CustomEvent('portal:services-ready'));
})();
